// // src/components/MarketSwitcher.jsx
// import React from 'react';
// import { useMarket } from '../context/MarketContext.jsx';

// const flags = { GB:'🇬🇧', US:'🇺🇸', AU:'🇦🇺', ES:'🇪🇸', DE:'🇩🇪', FR:'🇫🇷', JP:'🇯🇵', KR:'🇰🇷' };

// export default function MarketSwitcher() {
//   const { market, setMarket } = useMarket();

//   const handleChange = (e) => {
//     const country = e.target.value;
//     const langByCountry = { GB:'EN_GB', US:'EN_US', AU:'EN_AU', ES:'ES', DE:'DE', FR:'FR', JP:'JA', KR:'KO' };
//     setMarket({ country, language: langByCountry[country] || 'EN' });
//   };

//   const supported = ['GB','US','AU','ES','DE','FR','JP','KR'];

//   return (
//     <label className="inline-flex items-center gap-2 text-sm" aria-label="Select market">
//       <select
//         className="border rounded px-2 py-1"
//         value={market.country}
//         onChange={handleChange}
//         aria-label="Market"
//       >
//         {supported.map(code => (
//           <option key={code} value={code}>
//             {flags[code]} {code}
//           </option>
//         ))}
//       </select>
//     </label>
//   );
// }

// src/components/MarketSwitcher.jsx
import React from "react";
import { useMarket } from "../context/MarketContext.jsx";

export default function MarketSwitcher() {
  const { market, setMarket } = useMarket();
  const supported = ["UK", "US", "AU", "ES", "DE", "FR", "JP", "KR"];

  const handleChange = (e) => {
    const country = e.target.value;
    const langByCountry = {
      UK: "EN_GB",
      US: "EN_US",
      AU: "EN_AU",
      ES: "ES",
      DE: "DE",
      FR: "FR",
      JP: "JA",
      KR: "KO",
    };
    setMarket({ country, language: langByCountry[country] || "EN" });
  };

  return (
    <label className="inline-flex items-center text-xs italic" aria-label="Select market">
      <select
        className="
          bg-transparent 
          text-xs
          italic 
          focus:outline-none 
          cursor-pointer
          appearance-none
        "
        value={market.country}
        onChange={handleChange}
      >
        {supported.map((code) => (
          <option
            key={code}
            value={code}
            className="text-xs"
          >
            {code}
          </option>
        ))}
      </select>
    </label>
  );
}

